import React, { useEffect, useState } from 'react'
import AdminSidebar from './AdminSidebar';
import AdminHeader from './AdminHeader';
import axios from 'axios';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';


const base_url = process.env.REACT_APP_API_URL;

const UserChip = () => {
    const [isSidebarOpen, setIsSidebarOpen] = useState(!(window.innerWidth < 768));
    const [history, setHistory] = useState([]);
    const [originalHistory, setOriginalHistory] = useState([]);
    const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

    // Toggle sidebar visibility
    const toggleSidebar = () => {
        setIsSidebarOpen(!isSidebarOpen);
    };

    const fethcHistory = async () => {
        const auth = localStorage.getItem('admin');
        const response = await axios.get(base_url + '/api/webapi/user/chipHistory',
            {
                headers: {
                    Accept: 'application/json',
                    Authorization: `${auth}`
                }
            }
        )
        const hist = response.data.row;
        if (response?.data.success) {
            setHistory(hist);
            setOriginalHistory(hist);
        }
    }

    const handleChange = (e) => {
        const inputValue = e.target.value;

        if (inputValue === "") {
            setHistory(originalHistory);
        } else {
            const filterData = originalHistory.filter((val) => {
                const customerId = String(val.customerId);
                const providerId = String(val.providerId);
                return customerId.includes(inputValue) || providerId.includes(inputValue);
            });

            setHistory(filterData);
        }
    }

    const downloadPDF = () => {
      const doc = new jsPDF();
  
      doc.text('User Chip History', 14, 10);

      if (!history || history.length === 0) {
        alert('No data available to download.');
        return;
      }
  
      const tableColumn = ["Customer ID", "Customer Name", "Provider ID", "Provider Role", "Amount", "Debit/Credit", "IP", "Time"];
      const tableRows = [];
  
      history.forEach(item => {
          const rowData = [
              item.customerId,
              item.customerName,
              item.providerId,
              item.providerRole,
              item.amount,
              item.type,
              item.ip,
              item.time
          ];
          tableRows.push(rowData);
      });
  
      autoTable(doc, {
          head: [tableColumn],
          body: tableRows,
          startY: 20,
          theme: 'striped',
          headStyles: { fillColor: [22, 160, 133] },
          styles: { fontSize: 8 },
      });
  
      doc.save('user_chip_history.pdf');
    };
  

    useEffect(() => {
        window.scrollTo(0, 0);
        fethcHistory();
    }, []);

    useEffect(() => {
        const handleResize = () => {
          const mobile = window.innerWidth < 768;
          setIsMobile(mobile);
          
          // On desktop, sidebar should always be "open"
          if (!mobile) {
            setIsSidebarOpen(true);
          }
        };
        
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
      }, []);

    return (
        <div className="wrapper">
            {/* Main Sidebar */}
            <AdminSidebar 
          isSidebarOpen={isSidebarOpen} 
          toggleSidebar={toggleSidebar} 
          isMobile={isMobile}
        />
        
        {/* Header - Pass mobile info */}
        <AdminHeader 
          toggleSidebar={toggleSidebar} 
          isSidebarOpen={isSidebarOpen}
          isMobile={isMobile}
        />
        
        {/* Content Wrapper - Use conditional class and margin */}
        <div
          className={`content-wrapper ${
            !isMobile && isSidebarOpen ? "" : "open-content-wrapper"
          }`}
          style={{
            marginLeft: (!isMobile && isSidebarOpen) ? "" : "0",
            transition: "margin-left 0.3s ease"
          }}
        >
                <section className="content-header">
                    <div className="container-fluid">
                        <div className="row mb-2">
                            <div className="col-sm-6">
                                <h1>User Chip History</h1>
                            </div>
                        </div>
                    </div>
                </section>
                <div className="container-fluid">
                    <div className="card">
                        <div className="row">
                            <div className="col-md-12">
                                <div className='m-3 d-flex justify-content-between align-items-center'>
                                    <input
                                        type='text'
                                        placeholder='Enter customer id or provider id to seach'
                                        className='form-control'
                                        style={{ maxWidth: '300px' }}
                                        onChange={handleChange}
                                    />
                                    <button className='btn btn-success ml-2' onClick={downloadPDF}>
                                        Download PDF
                                    </button>
                                </div>
                                <div className='mt-4'>
                                    <table className="table table-responsive-sm">
                                        <thead>
                                            <tr className="p-2">
                                                <th className=" text-center text-nowrap">Customer ID</th>
                                                <th className=" text-center text-nowrap">Customer Name</th>
                                                <th className=" text-center text-nowrap">Provider Id</th>
                                                <th className=" text-center text-nowrap">Provider Role</th>
                                                <th className=" text-center text-nowrap">Amount</th>
                                                <th className=" text-center text-nowrap">Debit/Credit</th>
                                                <th className=" text-center text-nowrap">IP</th>
                                                <th className=" text-center text-nowrap">Time</th>
                                            </tr>
                                        </thead>

                                        <tbody>
                                            {history.map((data) => (
                                                <tr key={data.id}>
                                                    <td className='text-center'>{data.customerId}</td>
                                                    <td className='text-center'>{data.customerName}</td>
                                                    <td className='text-center'>{data.providerId}</td>
                                                    <td className='text-center'>{data.providerRole}</td>
                                                    <td className='text-center'>{data.amount}</td>
                                                    <td className='text-center' style={{ color: data.type === 'credit' ? 'rgb(3, 187, 22)' : 'rgba(255,0,0,1)' }}>{data.type}</td>
                                                    <td className='text-center'>{data.ip}</td>
                                                    <td className='text-center'>{data.time}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="mb-4" />
            </div>
        </div>
    )
}

export default UserChip;
